import { useEffect, useRef, useState } from "react";
import { IAutomationModel } from "../models/Models";
import { useEventHub } from "./EventHub";

export const useInterval = (callback: () => void, delay: number) => {

    const savedCallback = useRef<() => void>();

    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);


    useEffect(() => {
        function tick() {
            // @ts-ignore: Object is possibly 'null'.
            savedCallback.current();
        }
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}

export const fitGraph = (value: number, min: number, max: number) => {
    var range = max - min;
    return (value * .01 * range) + min;
}

export function delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function IsAndroidApp() {
    // samsung
    //Mozilla/5.0 (Linux; Android 14; SM-S921U1 Build/UP1A.231005.007; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/117.0.0.0 Mobile Safari/537.36
    return navigator.userAgent.includes('SM-S921U1') || navigator.userAgent.includes('Pixel 3 Build');
}

export function GetAndroidPadding() {
    if (navigator.userAgent.includes('SM-S921U1')) {
        return '55px';
    }
    else if (navigator.userAgent.includes('Pixel 3 Build')) {
        return "0px";
    }
}

export function IsTouch() {
    return matchMedia('(hover: none)').matches;
}

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

export function UseWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}

export function UseAutomations(automations: IAutomationModel[]) {
    const [a, setA] = useState(automations);

    useEventHub("*", (updated: IAutomationModel) => setA(a.map(i => i.id == updated.id ? updated : i)))

    return a;
}
